module.exports = __webpack_public_path__ + "media/images/next-b10ff486c78c15f86480c6ba14350459.svg";